<template>
  <div class="feedback-wrap">
    <!-- <div class="feedback-item">
      <img src="../assets/images/weixin.png" class="img" alt="微信公众号">
      <div class="hover-tip">
        <p class="text">微信扫码反馈问题</p>
        <img src="https://res.oodcd.cn/pan/images/feedback.jpg" alt="微信公众号二维码">
      </div>
    </div> -->
    <a class="feedback-item" href="http://alibabachanpinjingliwenjuan.mikecrm.com/YLPBx6a" target="_blank">
      <img src="../assets/images/feedback.png" class="img" alt="在线反馈">
       <div class="hover-tip">
        <p><a href="http://alibabachanpinjingliwenjuan.mikecrm.com/YLPBx6a" target="_blank">点此在线反馈问题</a> </p> 
      </div>
    </a>
  </div>
</template>
<script>
export default {
  
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_var.scss';

.feedback-wrap {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 44px;
  display: flex;
  flex-direction: column;
  .feedback-item {
    width: 44px;
    height: 44px;
    display: flex;
    margin-top: 15px;
    cursor: pointer;
    border-radius: 50%;
    align-items: center;
    justify-content: center;
    position: relative;
    background-color: $theme-color;
    box-shadow: 3px 3px 14px 0 rgba(0,0,0,0.2), -3px -3px 14px 0 rgba(0,0,0,0.2);
    .img {
      width: 24px;
      height: 24px;
    }
    &:hover {
      .hover-tip {
        visibility: visible;
        opacity: 1;
        bottom: 0px;
      }
    }
    .hover-tip {
      width: 180px;
      padding: 10px;
      display: flex;
      visibility: hidden;
      opacity: 0;
      flex-direction: column;
      align-items: center;
      position: absolute;
      text-align: center;
      border-radius: 4px;
      right: 60px;
      bottom: -60px;
      border: 1px solid #eee;
      background-color: #fff;
      transition: all ease 0.2s 0.1s;
      box-shadow: 2px 2px 14px 0 rgba(0,0,0,0.05), -2px -2px 14px 0 rgba(0,0,0,0.05);
      &:after {
        content: '';
        width: 0;
        height: 0;
        position: absolute;
        right: -12px;
        bottom: 10px;
        z-index: 1;
        border-top: 10px solid transparent;
        border-left: 12px solid #eee;
        border-bottom: 10px solid transparent;
      }
      &:before {
        content: '';
        width: 0;
        height: 0;
        position: absolute;
        right: -10px;
        bottom: 10px;
        z-index: 2;
        border-top: 10px solid transparent;
        border-left: 12px solid #fff;
        border-bottom: 10px solid transparent;
      }
      .text {
        font-weight: bold;
        color: #333;
      }
      img {
        width: 160px;
      }
    }
  }
}
  
@media (max-width: 700px) {
  .feedback-wrap {
    display: none;
  }
}
</style>